module.exports = "https://cdn.thelire.com/ins/resource/pic_order_vip@3x.47493fde0ebce65a9cd2a2c3c9874f14.png";